import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { 
  Calculator, Truck, Wrench, Package, MapPin, Info, 
  ArrowLeft, ChevronLeft, ChevronRight, Check, Loader2,
  User, Phone, Mail
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

// Workshop location: 1988 Woogenellup Road, Mount Barker WA 6324
const WORKSHOP_COORDS = { lat: -34.6297, lng: 117.6644 };

// WA Postcode approximate coordinates (major areas)
const WA_POSTCODE_COORDS = {
  // Perth Metro
  "6000": { lat: -31.9505, lng: 115.8605 },
  "6001": { lat: -31.9505, lng: 115.8605 },
  "6003": { lat: -31.9400, lng: 115.8700 },
  "6004": { lat: -31.9600, lng: 115.8700 },
  "6005": { lat: -31.9500, lng: 115.8400 },
  "6006": { lat: -31.9300, lng: 115.8400 },
  "6007": { lat: -31.9400, lng: 115.8300 },
  "6008": { lat: -31.9500, lng: 115.8100 },
  "6009": { lat: -31.9800, lng: 115.8100 },
  "6010": { lat: -31.9900, lng: 115.7600 },
  "6011": { lat: -31.9800, lng: 115.7400 },
  "6012": { lat: -31.9700, lng: 115.7500 },
  "6014": { lat: -31.9300, lng: 115.7900 },
  "6015": { lat: -31.9400, lng: 115.7600 },
  "6016": { lat: -31.9100, lng: 115.7900 },
  "6017": { lat: -31.8900, lng: 115.7900 },
  "6018": { lat: -31.8700, lng: 115.7600 },
  "6019": { lat: -31.8500, lng: 115.7600 },
  "6020": { lat: -31.8300, lng: 115.7500 },
  "6021": { lat: -31.8600, lng: 115.8200 },
  "6022": { lat: -31.8400, lng: 115.8200 },
  "6023": { lat: -31.8200, lng: 115.7800 },
  "6024": { lat: -31.7900, lng: 115.7700 },
  "6025": { lat: -31.7700, lng: 115.7600 },
  "6026": { lat: -31.8500, lng: 115.8500 },
  "6027": { lat: -31.7400, lng: 115.7700 },
  "6028": { lat: -31.7200, lng: 115.7600 },
  "6029": { lat: -31.8600, lng: 115.7700 },
  "6030": { lat: -31.6800, lng: 115.7100 },
  "6031": { lat: -31.6600, lng: 115.7000 },
  "6032": { lat: -31.6400, lng: 115.6800 },
  "6050": { lat: -31.9200, lng: 115.8700 },
  "6051": { lat: -31.9100, lng: 115.8900 },
  "6052": { lat: -31.9000, lng: 115.9000 },
  "6053": { lat: -31.8800, lng: 115.9100 },
  "6054": { lat: -31.8900, lng: 115.9400 },
  "6055": { lat: -31.8800, lng: 116.0200 },
  "6056": { lat: -31.8600, lng: 116.0500 },
  "6057": { lat: -31.8900, lng: 116.0700 },
  "6058": { lat: -31.9100, lng: 116.0500 },
  "6059": { lat: -31.8700, lng: 115.9000 },
  "6060": { lat: -31.8700, lng: 115.8700 },
  "6061": { lat: -31.8500, lng: 115.8700 },
  "6062": { lat: -31.8400, lng: 115.9200 },
  "6063": { lat: -31.8300, lng: 115.9400 },
  "6064": { lat: -31.8000, lng: 115.8600 },
  "6065": { lat: -31.7800, lng: 115.8400 },
  "6066": { lat: -31.7600, lng: 115.9000 },
  "6067": { lat: -31.7200, lng: 115.8500 },
  "6068": { lat: -31.8000, lng: 116.0000 },
  "6069": { lat: -31.7500, lng: 116.0500 },
  "6070": { lat: -31.8800, lng: 116.1000 },
  "6071": { lat: -31.9200, lng: 116.1300 },
  "6076": { lat: -32.0200, lng: 116.0800 },
  "6077": { lat: -31.7000, lng: 116.0000 },
  "6090": { lat: -31.8600, lng: 115.9800 },
  "6100": { lat: -31.9700, lng: 115.8900 },
  "6101": { lat: -31.9800, lng: 115.9000 },
  "6102": { lat: -31.9800, lng: 115.9300 },
  "6103": { lat: -31.9600, lng: 115.9400 },
  "6104": { lat: -31.9500, lng: 115.9600 },
  "6105": { lat: -31.9400, lng: 115.9800 },
  "6106": { lat: -31.9600, lng: 115.9800 },
  "6107": { lat: -31.9800, lng: 116.0000 },
  "6108": { lat: -32.0000, lng: 115.9800 },
  "6109": { lat: -32.0200, lng: 116.0000 },
  "6110": { lat: -32.0400, lng: 116.0000 },
  "6111": { lat: -32.0600, lng: 116.0200 },
  "6112": { lat: -32.1000, lng: 116.0000 },
  "6121": { lat: -32.2000, lng: 115.9500 },
  "6122": { lat: -32.3000, lng: 116.0000 },
  "6148": { lat: -32.0400, lng: 115.8800 },
  "6149": { lat: -32.0600, lng: 115.8500 },
  "6150": { lat: -32.0500, lng: 115.8300 },
  "6151": { lat: -32.0200, lng: 115.8400 },
  "6152": { lat: -32.0000, lng: 115.8600 },
  "6153": { lat: -32.0200, lng: 115.8000 },
  "6154": { lat: -32.0400, lng: 115.7800 },
  "6155": { lat: -32.0700, lng: 115.8200 },
  "6156": { lat: -32.0400, lng: 115.7500 },
  "6157": { lat: -32.0600, lng: 115.7400 },
  "6158": { lat: -32.0500, lng: 115.7600 },
  "6159": { lat: -32.0800, lng: 115.7500 },
  "6160": { lat: -32.0500, lng: 115.7400 },
  "6163": { lat: -32.1000, lng: 115.7700 },
  "6164": { lat: -32.1200, lng: 115.8200 },
  "6166": { lat: -32.1800, lng: 115.7700 },
  "6167": { lat: -32.2200, lng: 115.7800 },
  "6168": { lat: -32.3000, lng: 115.7600 },
  "6169": { lat: -32.3200, lng: 115.7400 },
  "6170": { lat: -32.3500, lng: 115.7200 },
  "6171": { lat: -32.3800, lng: 115.7500 },
  "6172": { lat: -32.4200, lng: 115.7600 },
  "6173": { lat: -32.3400, lng: 115.7800 },
  "6174": { lat: -32.4800, lng: 115.7500 },
  "6175": { lat: -32.5200, lng: 115.7300 },
  "6176": { lat: -32.0900, lng: 115.8200 },
  "6180": { lat: -32.5500, lng: 115.7200 },
  "6208": { lat: -32.6300, lng: 115.8800 },
  "6209": { lat: -32.7000, lng: 115.8500 },
  "6210": { lat: -32.5300, lng: 115.7400 },
  "6211": { lat: -32.5000, lng: 115.6800 },
  "6213": { lat: -32.8000, lng: 115.9000 },
  "6215": { lat: -32.9500, lng: 115.9000 },
  "6218": { lat: -33.0000, lng: 115.8500 },
  "6220": { lat: -33.3000, lng: 115.6500 },
  "6221": { lat: -33.3300, lng: 115.6400 },
  "6223": { lat: -33.3200, lng: 115.7000 },
  "6224": { lat: -33.3500, lng: 115.7200 },
  "6225": { lat: -33.2800, lng: 115.7500 },
  "6226": { lat: -33.3500, lng: 115.8000 },
  "6227": { lat: -33.4000, lng: 115.6800 },
  "6228": { lat: -33.6000, lng: 115.3500 },
  "6229": { lat: -33.6500, lng: 115.3500 },
  "6230": { lat: -33.3500, lng: 115.6500 },
  "6231": { lat: -33.3300, lng: 115.6300 },
  "6232": { lat: -33.3100, lng: 115.6800 },
  "6233": { lat: -33.3800, lng: 115.6200 },
  "6236": { lat: -33.1500, lng: 116.0500 },
  "6237": { lat: -33.7000, lng: 115.3000 },
  "6239": { lat: -33.8500, lng: 115.1000 },
  "6240": { lat: -33.9500, lng: 115.0800 },
  "6243": { lat: -34.0500, lng: 115.0500 },
  "6244": { lat: -34.2000, lng: 115.1500 },
  "6251": { lat: -33.9500, lng: 116.0500 },
  "6253": { lat: -33.9000, lng: 116.2000 },
  "6255": { lat: -34.0500, lng: 116.4500 },
  "6256": { lat: -34.2000, lng: 116.2000 },
  "6258": { lat: -34.4000, lng: 116.6500 },
  "6260": { lat: -34.4500, lng: 117.1500 },
  "6270": { lat: -34.5000, lng: 117.3000 },
  "6271": { lat: -34.5500, lng: 117.4500 },
  "6280": { lat: -33.7500, lng: 115.4000 },
  "6281": { lat: -33.6800, lng: 115.3500 },
  "6282": { lat: -33.8000, lng: 115.2500 },
  "6285": { lat: -33.9500, lng: 115.1000 },
  "6286": { lat: -34.0000, lng: 115.0000 },
  "6290": { lat: -34.9500, lng: 117.8000 },
  "6302": { lat: -31.6500, lng: 116.6500 },
  "6304": { lat: -31.8500, lng: 117.0000 },
  "6306": { lat: -32.1000, lng: 117.2000 },
  "6308": { lat: -32.4000, lng: 117.1000 },
  "6309": { lat: -32.5500, lng: 117.0500 },
  "6311": { lat: -32.7500, lng: 117.1500 },
  "6312": { lat: -32.9500, lng: 117.2000 },
  "6315": { lat: -33.3500, lng: 117.1500 },
  "6317": { lat: -33.7000, lng: 117.6500 },
  "6320": { lat: -34.2000, lng: 117.8500 },
  "6321": { lat: -34.0500, lng: 117.6500 },
  "6322": { lat: -34.3000, lng: 118.1500 },
  "6323": { lat: -34.4000, lng: 117.6500 },
  "6324": { lat: -34.6297, lng: 117.6644 },
  "6326": { lat: -34.7500, lng: 117.8500 },
  "6327": { lat: -34.8500, lng: 117.7500 },
  "6328": { lat: -34.9500, lng: 118.3000 },
  "6330": { lat: -34.9505, lng: 117.8030 },
  "6331": { lat: -34.9400, lng: 117.8100 },
  "6332": { lat: -34.9300, lng: 117.8200 },
  "6333": { lat: -34.9200, lng: 117.7800 },
  "6335": { lat: -34.8000, lng: 118.5000 },
  "6336": { lat: -34.7500, lng: 118.8000 },
  "6337": { lat: -34.5000, lng: 118.5000 },
  "6341": { lat: -33.5000, lng: 118.5000 },
  "6343": { lat: -33.1000, lng: 119.0000 },
  "6346": { lat: -33.0000, lng: 118.3000 },
  "6348": { lat: -32.7000, lng: 118.2000 },
  "6350": { lat: -32.5000, lng: 118.0000 },
  "6352": { lat: -32.2500, lng: 118.5000 },
  "6353": { lat: -32.0500, lng: 118.5000 },
  "6355": { lat: -32.3500, lng: 119.2000 },
  "6358": { lat: -31.5000, lng: 118.5000 },
  "6361": { lat: -31.3500, lng: 118.7000 },
  "6363": { lat: -31.1500, lng: 117.5500 },
  "6365": { lat: -31.2500, lng: 117.8000 },
  "6367": { lat: -31.5000, lng: 117.8000 },
  "6370": { lat: -31.2000, lng: 116.8500 },
  "6372": { lat: -31.0000, lng: 116.8000 },
  "6373": { lat: -30.9500, lng: 117.0000 },
  "6375": { lat: -30.7500, lng: 117.2000 },
  "6383": { lat: -30.6000, lng: 117.5000 },
  "6390": { lat: -32.0500, lng: 116.3500 },
  "6391": { lat: -32.1500, lng: 116.2500 },
  "6392": { lat: -32.4000, lng: 116.1500 },
  "6393": { lat: -32.5500, lng: 116.2000 },
  "6394": { lat: -32.7500, lng: 116.1000 },
  "6395": { lat: -32.9000, lng: 116.5000 },
  "6396": { lat: -33.1000, lng: 116.8000 },
  "6397": { lat: -33.0500, lng: 117.0000 },
  "6398": { lat: -33.2000, lng: 117.3000 },
  "6430": { lat: -30.7500, lng: 121.4700 },
  "6431": { lat: -30.7300, lng: 121.4500 },
  "6432": { lat: -30.7600, lng: 121.5000 },
  "6433": { lat: -30.8500, lng: 121.8000 },
  "6434": { lat: -31.1500, lng: 121.5500 },
  "6436": { lat: -30.3000, lng: 121.0000 },
  "6437": { lat: -29.0000, lng: 121.5000 },
  "6440": { lat: -32.0000, lng: 121.0000 },
  "6442": { lat: -31.1500, lng: 121.0000 },
  "6443": { lat: -32.5000, lng: 121.5000 },
  "6445": { lat: -33.0000, lng: 121.5000 },
  "6446": { lat: -33.2500, lng: 121.8000 },
  "6450": { lat: -33.8610, lng: 121.8920 },
  "6460": { lat: -29.2500, lng: 116.0000 },
  "6461": { lat: -29.0000, lng: 115.5000 },
  "6462": { lat: -28.7500, lng: 115.8500 },
  "6463": { lat: -29.4500, lng: 116.2500 },
  "6465": { lat: -28.5500, lng: 115.0000 },
  "6466": { lat: -29.1000, lng: 115.1000 },
  "6467": { lat: -29.4500, lng: 115.0500 },
  "6468": { lat: -29.7000, lng: 115.3000 },
  "6470": { lat: -29.0500, lng: 115.5000 },
  "6472": { lat: -28.7800, lng: 114.6150 },
  "6475": { lat: -28.5000, lng: 114.1500 },
  "6476": { lat: -27.8500, lng: 114.6000 },
  "6479": { lat: -26.5000, lng: 118.5000 },
  "6480": { lat: -25.0500, lng: 117.8500 },
  "6484": { lat: -28.2000, lng: 117.5000 },
  "6485": { lat: -27.7500, lng: 117.2000 },
  "6487": { lat: -27.2000, lng: 117.8000 },
  "6488": { lat: -26.7500, lng: 120.5000 },
  "6490": { lat: -28.5500, lng: 114.6000 },
  "6507": { lat: -29.6000, lng: 117.2000 },
  "6510": { lat: -28.8000, lng: 114.6000 },
  "6525": { lat: -20.7500, lng: 116.8500 },
  "6530": { lat: -28.7800, lng: 114.6150 },
  "6556": { lat: -31.8500, lng: 116.0000 },
  "6558": { lat: -31.8000, lng: 116.0500 },
  "6560": { lat: -31.7800, lng: 116.0200 },
  "6562": { lat: -31.7500, lng: 116.0800 },
  "6564": { lat: -31.8200, lng: 115.9500 },
  "6566": { lat: -31.8000, lng: 116.1500 },
  "6567": { lat: -31.6500, lng: 116.0000 },
  "6568": { lat: -31.6200, lng: 116.1000 },
  "6569": { lat: -31.5800, lng: 116.0500 },
  "6571": { lat: -31.5000, lng: 116.0000 },
  "6572": { lat: -31.4500, lng: 116.1000 },
  "6574": { lat: -31.3500, lng: 116.2000 },
  "6623": { lat: -30.0500, lng: 116.0000 },
  "6625": { lat: -29.7500, lng: 116.3000 },
  "6627": { lat: -30.2500, lng: 117.5000 },
  "6628": { lat: -30.1500, lng: 117.0000 },
  "6630": { lat: -29.8500, lng: 116.0000 },
  "6631": { lat: -30.5500, lng: 116.8000 },
  "6632": { lat: -30.3500, lng: 116.0000 },
  "6635": { lat: -30.2000, lng: 116.3500 },
  "6638": { lat: -30.8000, lng: 116.2000 },
  "6639": { lat: -30.9500, lng: 116.5000 },
  "6640": { lat: -30.7500, lng: 116.5000 },
  "6642": { lat: -30.5000, lng: 115.9000 },
  "6646": { lat: -30.5500, lng: 115.5000 },
  "6701": { lat: -22.2000, lng: 114.2000 },
  "6710": { lat: -21.6000, lng: 115.0000 },
  "6711": { lat: -23.3500, lng: 119.7500 },
  "6712": { lat: -23.2000, lng: 117.8500 },
  "6714": { lat: -20.7500, lng: 116.8500 },
  "6716": { lat: -20.6500, lng: 116.7000 },
  "6718": { lat: -20.3500, lng: 118.6000 },
  "6720": { lat: -20.7500, lng: 116.8500 },
  "6721": { lat: -20.3000, lng: 118.5800 },
  "6725": { lat: -17.9600, lng: 122.2400 },
  "6726": { lat: -17.9500, lng: 122.2300 },
  "6728": { lat: -18.2000, lng: 125.8000 },
  "6731": { lat: -17.3500, lng: 123.6000 },
  "6733": { lat: -16.5000, lng: 123.0000 },
  "6740": { lat: -15.7700, lng: 128.7400 },
  "6743": { lat: -15.5500, lng: 128.2500 },
  "6751": { lat: -23.1200, lng: 117.6000 },
  "6753": { lat: -22.5000, lng: 118.5000 },
  "6758": { lat: -20.7500, lng: 116.8500 },
  "6760": { lat: -20.6000, lng: 116.8000 },
  "6765": { lat: -20.3500, lng: 118.6000 },
  "6770": { lat: -17.9600, lng: 122.2400 },
};

// Haversine formula
const calculateDistance = (lat1, lng1, lat2, lng2) => {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
    Math.sin(dLng/2) * Math.sin(dLng/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
};

const getPostcodeCoords = (postcode) => {
  const cleanPostcode = postcode.replace(/\s/g, '');
  if (WA_POSTCODE_COORDS[cleanPostcode]) {
    return WA_POSTCODE_COORDS[cleanPostcode];
  }
  const prefix = cleanPostcode.substring(0, 3);
  const matches = Object.keys(WA_POSTCODE_COORDS).filter(p => p.startsWith(prefix));
  if (matches.length > 0) {
    return WA_POSTCODE_COORDS[matches[0]];
  }
  return WA_POSTCODE_COORDS["6000"];
};

const productImages = [
  "/IMG_6286_shelter_main.jpeg",
  "/IMG_6296.jpeg", 
  "/shelter_normal.jpg",
  "/shelter_new1.jpg",
  "/shelter_new2.jpg"
];

export default function LivestockShelterPage() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [kickBoards, setKickBoards] = useState(false);
  const [deliveryOption, setDeliveryOption] = useState("pickup");
  const [postcode, setPostcode] = useState("");
  const [distance, setDistance] = useState(null);
  const [travelTime, setTravelTime] = useState(null);
  const [postcodeError, setPostcodeError] = useState("");
  
  // Customer details
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [quoteSubmitted, setQuoteSubmitted] = useState(false);

  // Prices
  const KIT_PRICE = 4500;
  const KICK_BOARDS_PRICE = 1000;
  const INSTALLATION_FEE = 1500;
  const INSTALL_RATE_PER_KM = 4;
  const DELIVERY_RATE_PER_KM = 2;
  const HOURLY_TRAVEL_RATE = 30;
  const AVG_SPEED_KMH = 80;

  useEffect(() => {
    if (postcode.length >= 4 && (deliveryOption === "installation" || deliveryOption === "delivery")) {
      calculateTravelDistance();
    } else {
      setDistance(null);
      setTravelTime(null);
    }
  }, [postcode, deliveryOption]);

  const calculateTravelDistance = () => {
    const cleanPostcode = postcode.replace(/\s/g, '');
    if (!cleanPostcode.match(/^6\d{3}$/)) {
      setPostcodeError("Please enter a valid WA postcode (e.g., 6330)");
      setDistance(null);
      setTravelTime(null);
      return;
    }
    setPostcodeError("");
    const coords = getPostcodeCoords(cleanPostcode);
    const straightLineDistance = calculateDistance(
      WORKSHOP_COORDS.lat, WORKSHOP_COORDS.lng, coords.lat, coords.lng
    );
    const roadDistance = Math.round(straightLineDistance * 1.3);
    const returnDistance = roadDistance * 2;
    const travelHours = (roadDistance / AVG_SPEED_KMH) * 2;
    setDistance(returnDistance);
    setTravelTime(travelHours);
  };

  const calculateTotal = () => {
    let subtotal = KIT_PRICE;
    if (kickBoards) subtotal += KICK_BOARDS_PRICE;
    if (deliveryOption === "installation") subtotal += INSTALLATION_FEE;
    
    let travelCost = 0;
    if (distance && travelTime) {
      if (deliveryOption === "installation") {
        travelCost = (distance * INSTALL_RATE_PER_KM) + (travelTime * HOURLY_TRAVEL_RATE);
      } else if (deliveryOption === "delivery") {
        travelCost = (distance * DELIVERY_RATE_PER_KM) + (travelTime * HOURLY_TRAVEL_RATE);
      }
    }
    subtotal += travelCost;
    const gst = subtotal * 0.1;
    const total = subtotal + gst;
    return { subtotal, gst, total, travelCost };
  };

  const { subtotal, gst, total, travelCost } = calculateTotal();
  const needsPostcode = deliveryOption === "installation" || deliveryOption === "delivery";

  const getDeliveryOptionText = () => {
    switch(deliveryOption) {
      case "pickup": return "Local Pickup (FREE)";
      case "none": return "Kit Only (No Installation)";
      case "delivery": return `Delivery Only (${distance ? distance + "km return" : "postcode required"})`;
      case "installation": return `Full Installation (${distance ? distance + "km return" : "postcode required"})`;
      default: return "";
    }
  };

  const handleSubmitQuote = async (e) => {
    e.preventDefault();
    
    if (!customerName.trim() || !customerPhone.trim()) {
      toast.error("Please enter your name and phone number");
      return;
    }

    if (needsPostcode && !postcode) {
      toast.error("Please enter your postcode for delivery/installation");
      return;
    }

    setIsSubmitting(true);

    try {
      const quoteData = {
        customerName,
        customerPhone,
        customerEmail,
        postcode: needsPostcode ? postcode : "N/A (Local Pickup)",
        kickBoards,
        deliveryOption: getDeliveryOptionText(),
        distance: distance || 0,
        travelTime: travelTime || 0,
        kitPrice: KIT_PRICE,
        kickBoardsPrice: kickBoards ? KICK_BOARDS_PRICE : 0,
        installationFee: deliveryOption === "installation" ? INSTALLATION_FEE : 0,
        travelCost: Math.round(travelCost),
        subtotal: Math.round(subtotal),
        gst: Math.round(gst),
        total: Math.round(total)
      };

      const response = await fetch(`${API_URL}/api/send-quote`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(quoteData),
      });

      if (!response.ok) throw new Error("Failed to send quote");

      setQuoteSubmitted(true);
      toast.success("Quote request sent! We'll be in touch soon.");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong. Please try again or call us directly.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const nextImage = () => setCurrentImageIndex((prev) => (prev + 1) % productImages.length);
  const prevImage = () => setCurrentImageIndex((prev) => (prev - 1 + productImages.length) % productImages.length);

  if (quoteSubmitted) {
    return (
      <div className="page-transition pt-20 min-h-screen bg-[#0A0A0A]">
        <Helmet>
          <title>Quote Submitted | PWC Fabrication & Engineering</title>
        </Helmet>
        <div className="max-w-2xl mx-auto px-4 py-20 text-center">
          <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Check className="w-10 h-10 text-green-500" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-4">Quote Request Sent!</h1>
          <p className="text-[#A3A3A3] mb-8">
            Thanks {customerName}! We've received your quote request for the 4-5m Livestock Shelter.
            We'll review your requirements and get back to you shortly.
          </p>
          <div className="bg-[#1A1A1A] rounded-2xl p-6 mb-8 text-left">
            <h3 className="text-lg font-bold text-white mb-4">Your Quote Summary</h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between"><span className="text-[#A3A3A3]">Kit Price</span><span className="text-white">${KIT_PRICE.toLocaleString()}</span></div>
              {kickBoards && <div className="flex justify-between"><span className="text-[#A3A3A3]">Kick Boards</span><span className="text-white">+${KICK_BOARDS_PRICE.toLocaleString()}</span></div>}
              {deliveryOption === "installation" && <div className="flex justify-between"><span className="text-[#A3A3A3]">Installation</span><span className="text-white">+${INSTALLATION_FEE.toLocaleString()}</span></div>}
              {travelCost > 0 && <div className="flex justify-between"><span className="text-[#A3A3A3]">Travel</span><span className="text-white">+${Math.round(travelCost).toLocaleString()}</span></div>}
              <div className="flex justify-between pt-2 border-t border-[#2A2A2A]"><span className="text-[#A3A3A3]">GST</span><span className="text-white">${Math.round(gst).toLocaleString()}</span></div>
              <div className="flex justify-between pt-2 border-t border-[#E63946]/30"><span className="text-white font-bold">Total (inc. GST)</span><span className="text-[#E63946] font-bold text-xl">${Math.round(total).toLocaleString()}</span></div>
            </div>
          </div>
          <Link to="/products">
            <Button className="bg-[#E63946] hover:bg-[#D62839] text-white font-bold px-8 py-3 rounded-full">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Products
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="page-transition pt-20 min-h-screen bg-[#0A0A0A] overflow-x-hidden">
      <Helmet>
        <title>4-5m Livestock Shelter | PWC Fabrication & Engineering</title>
        <meta name="description" content="Get a quote for our standard 4-5m livestock shelter. Heavy-duty steel frame, optional kick boards, delivery and installation available across Western Australia." />
      </Helmet>

      {/* Back Link */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <Link to="/products" className="inline-flex items-center gap-2 text-[#A3A3A3] hover:text-white transition-colors">
          <ArrowLeft className="w-4 h-4" />
          <span>Back to Products</span>
        </Link>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 overflow-x-hidden">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Left: Images */}
          <div className="min-w-0">
            <div className="aspect-[4/3] bg-[#1A1A1A] rounded-2xl overflow-hidden relative group">
              <img 
                src={productImages[currentImageIndex]} 
                alt="4-5m Livestock Shelter"
                className="w-full h-full object-cover"
              />
              {productImages.length > 1 && (
                <>
                  <button onClick={prevImage} className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity">
                    <ChevronLeft className="w-6 h-6" />
                  </button>
                  <button onClick={nextImage} className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity">
                    <ChevronRight className="w-6 h-6" />
                  </button>
                  <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
                    {productImages.map((_, i) => (
                      <button key={i} onClick={() => setCurrentImageIndex(i)} className={`w-2 h-2 rounded-full transition-colors ${i === currentImageIndex ? 'bg-[#E63946]' : 'bg-white/50'}`} />
                    ))}
                  </div>
                </>
              )}
            </div>
            
            {/* Thumbnails */}
            <div className="flex gap-3 mt-4 overflow-x-auto pb-2">
              {productImages.map((img, i) => (
                <button key={i} onClick={() => setCurrentImageIndex(i)} className={`flex-shrink-0 w-20 h-16 rounded-lg overflow-hidden border-2 transition-colors ${i === currentImageIndex ? 'border-[#E63946]' : 'border-transparent'}`}>
                  <img src={img} alt={`View ${i + 1}`} className="w-full h-full object-cover" />
                </button>
              ))}
            </div>

            {/* Product Description */}
            <div className="mt-8">
              <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">4-5m Livestock Shelter</h1>
              <p className="text-[#A3A3A3] text-lg mb-6">
                Our standard-sized heavy-duty steel frame shelter, built for Australian conditions. 
                Protect your livestock from sun, wind, and rain with our proven 4-5 metre design.
              </p>
              <ul className="space-y-3">
                {["Standard 4-5 metre span", "Heavy-duty steel frame construction", "Optional kick boards available", "Delivery & installation across WA"].map((feature, i) => (
                  <li key={i} className="flex items-center gap-3 text-[#A3A3A3]">
                    <Check className="w-5 h-5 text-[#E63946]" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right: Quote Calculator */}
          <div className="min-w-0">
            <div className="bg-[#141414] border border-[#2A2A2A] rounded-2xl p-4 sm:p-6 sticky top-24">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#E63946]/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Calculator className="w-5 h-5 sm:w-6 sm:h-6 text-[#E63946]" />
                </div>
                <div className="min-w-0">
                  <h2 className="text-lg sm:text-xl font-bold text-white">Build Your Quote</h2>
                  <p className="text-sm text-[#737373]">Customise your shelter options</p>
                </div>
              </div>

              {/* Base Price */}
              <div className="bg-[#1A1A1A] rounded-xl p-4 mb-4">
                <div className="flex justify-between items-center gap-2">
                  <div className="flex items-center gap-2 sm:gap-3 min-w-0">
                    <Package className="w-5 h-5 text-[#E63946] flex-shrink-0" />
                    <span className="text-white font-medium text-sm sm:text-base">4-5m Livestock Shelter Kit</span>
                  </div>
                  <span className="text-white font-bold flex-shrink-0">${KIT_PRICE.toLocaleString()}</span>
                </div>
              </div>

              {/* Kick Boards */}
              <label className="flex items-center gap-3 bg-[#1A1A1A] rounded-xl p-4 cursor-pointer hover:bg-[#222] transition-colors mb-4">
                <input type="checkbox" checked={kickBoards} onChange={(e) => setKickBoards(e.target.checked)} className="w-5 h-5 rounded border-[#2A2A2A] bg-[#0A0A0A] text-[#E63946] focus:ring-[#E63946]" />
                <div className="flex-1">
                  <span className="text-white font-medium">Add Kick Boards</span>
                  <p className="text-sm text-[#737373]">Protective boards around the base</p>
                </div>
                <span className="text-[#E63946] font-bold">+${KICK_BOARDS_PRICE.toLocaleString()}</span>
              </label>

              {/* Delivery Options */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-[#A3A3A3] mb-2">
                  <Truck className="w-4 h-4 inline mr-2" />
                  Delivery & Installation
                </label>
                <div className="space-y-2">
                  <label className={`flex items-start gap-3 p-4 rounded-xl cursor-pointer transition-colors ${deliveryOption === 'pickup' ? 'bg-[#E63946]/10 border border-[#E63946]/30' : 'bg-[#1A1A1A] hover:bg-[#222]'}`}>
                    <input type="radio" name="delivery" value="pickup" checked={deliveryOption === "pickup"} onChange={(e) => setDeliveryOption(e.target.value)} className="mt-1 w-4 h-4 text-[#E63946] bg-[#0A0A0A] border-[#2A2A2A]" />
                    <div className="flex-1">
                      <span className="text-white font-medium">Local Pickup</span>
                      <p className="text-sm text-[#737373]">Collect from our workshop</p>
                      <p className="text-xs text-[#525252] mt-1"><MapPin className="w-3 h-3 inline mr-1" />1988 Woogenellup Road, WA 6324</p>
                    </div>
                    <span className="text-green-500 font-medium text-sm">FREE</span>
                  </label>

                  <label className={`flex items-start gap-3 p-4 rounded-xl cursor-pointer transition-colors ${deliveryOption === 'none' ? 'bg-[#E63946]/10 border border-[#E63946]/30' : 'bg-[#1A1A1A] hover:bg-[#222]'}`}>
                    <input type="radio" name="delivery" value="none" checked={deliveryOption === "none"} onChange={(e) => setDeliveryOption(e.target.value)} className="mt-1 w-4 h-4 text-[#E63946] bg-[#0A0A0A] border-[#2A2A2A]" />
                    <div className="flex-1">
                      <span className="text-white font-medium">Kit Only (No Installation)</span>
                      <p className="text-sm text-[#737373]">Self-install - we can arrange delivery separately</p>
                    </div>
                  </label>

                  <label className={`flex items-start gap-3 p-4 rounded-xl cursor-pointer transition-colors ${deliveryOption === 'delivery' ? 'bg-[#E63946]/10 border border-[#E63946]/30' : 'bg-[#1A1A1A] hover:bg-[#222]'}`}>
                    <input type="radio" name="delivery" value="delivery" checked={deliveryOption === "delivery"} onChange={(e) => setDeliveryOption(e.target.value)} className="mt-1 w-4 h-4 text-[#E63946] bg-[#0A0A0A] border-[#2A2A2A]" />
                    <div className="flex-1">
                      <span className="text-white font-medium">Delivery Only</span>
                      <p className="text-sm text-[#737373]">We deliver, you install</p>
                      <p className="text-xs text-[#737373] mt-1">$2/km (return trip) + $30/hr travel time</p>
                    </div>
                  </label>

                  <label className={`flex items-start gap-3 p-4 rounded-xl cursor-pointer transition-colors ${deliveryOption === 'installation' ? 'bg-[#E63946]/10 border border-[#E63946]/30' : 'bg-[#1A1A1A] hover:bg-[#222]'}`}>
                    <input type="radio" name="delivery" value="installation" checked={deliveryOption === "installation"} onChange={(e) => setDeliveryOption(e.target.value)} className="mt-1 w-4 h-4 text-[#E63946] bg-[#0A0A0A] border-[#2A2A2A]" />
                    <div className="flex-1">
                      <div className="flex items-center gap-2">
                        <Wrench className="w-4 h-4 text-[#E63946]" />
                        <span className="text-white font-medium">Full Installation</span>
                      </div>
                      <p className="text-sm text-[#737373]">We deliver and install for you</p>
                      <p className="text-xs text-[#737373] mt-1">+$1,500 installation + $4/km (return) + $30/hr</p>
                    </div>
                  </label>
                </div>
              </div>

              {/* Postcode Input */}
              {needsPostcode && (
                <div className="mb-4">
                  <label className="block text-sm font-medium text-[#A3A3A3] mb-2">
                    <MapPin className="w-4 h-4 inline mr-2" />
                    Your Postcode
                  </label>
                  <input type="text" value={postcode} onChange={(e) => setPostcode(e.target.value.replace(/\D/g, '').slice(0, 4))} placeholder="e.g., 6330" className="w-full px-4 py-3 bg-[#1A1A1A] border border-[#2A2A2A] rounded-xl text-white text-base placeholder-[#525252] focus:outline-none focus:border-[#E63946]" maxLength={4} />
                  {postcodeError && <p className="text-red-500 text-sm mt-2">{postcodeError}</p>}
                  {distance && (
                    <div className="mt-3 p-3 bg-[#1A1A1A] rounded-lg">
                      <p className="text-sm text-[#A3A3A3]"><span className="text-white font-medium">{distance} km</span> return trip</p>
                      <p className="text-sm text-[#A3A3A3]">Est. travel time: <span className="text-white font-medium">{travelTime.toFixed(1)} hours</span></p>
                    </div>
                  )}
                </div>
              )}

              {/* Price Breakdown */}
              <div className="border-t border-[#2A2A2A] pt-4 mt-4">
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between text-[#A3A3A3]"><span>Kit Price</span><span className="text-white">${KIT_PRICE.toLocaleString()}</span></div>
                  {kickBoards && <div className="flex justify-between text-[#A3A3A3]"><span>Kick Boards</span><span className="text-white">+${KICK_BOARDS_PRICE.toLocaleString()}</span></div>}
                  {deliveryOption === "installation" && <div className="flex justify-between text-[#A3A3A3]"><span>Installation Fee</span><span className="text-white">+${INSTALLATION_FEE.toLocaleString()}</span></div>}
                  {travelCost > 0 && <div className="flex justify-between text-[#A3A3A3]"><span>{deliveryOption === "installation" ? "Travel (Install)" : "Delivery"}</span><span className="text-white">+${Math.round(travelCost).toLocaleString()}</span></div>}
                  <div className="flex justify-between text-[#A3A3A3] pt-2 border-t border-[#2A2A2A]"><span>Subtotal (excl. GST)</span><span className="text-white">${Math.round(subtotal).toLocaleString()}</span></div>
                  <div className="flex justify-between text-[#A3A3A3]"><span>GST (10%)</span><span className="text-white">${Math.round(gst).toLocaleString()}</span></div>
                </div>
                <div className="flex justify-between items-center mt-4 pt-4 border-t border-[#E63946]/30">
                  <span className="text-lg font-bold text-white">Total (inc. GST)</span>
                  <span className="text-3xl font-bold text-[#E63946]">${Math.round(total).toLocaleString()}</span>
                </div>
              </div>

              {/* Customer Details Form */}
              <form onSubmit={handleSubmitQuote} className="mt-6 pt-6 border-t border-[#2A2A2A]">
                <h3 className="text-lg font-bold text-white mb-4">Your Details</h3>
                <div className="space-y-3">
                  <div className="relative">
                    <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#525252]" />
                    <input type="text" value={customerName} onChange={(e) => setCustomerName(e.target.value)} placeholder="Your name *" className="w-full pl-12 pr-4 py-3 bg-[#1A1A1A] border border-[#2A2A2A] rounded-xl text-white text-base placeholder-[#525252] focus:outline-none focus:border-[#E63946]" required />
                  </div>
                  <div className="relative">
                    <Phone className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#525252]" />
                    <input type="tel" value={customerPhone} onChange={(e) => setCustomerPhone(e.target.value)} placeholder="Phone number *" className="w-full pl-12 pr-4 py-3 bg-[#1A1A1A] border border-[#2A2A2A] rounded-xl text-white text-base placeholder-[#525252] focus:outline-none focus:border-[#E63946]" required />
                  </div>
                  <div className="relative">
                    <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#525252]" />
                    <input type="email" value={customerEmail} onChange={(e) => setCustomerEmail(e.target.value)} placeholder="Email (optional)" className="w-full pl-12 pr-4 py-3 bg-[#1A1A1A] border border-[#2A2A2A] rounded-xl text-white text-base placeholder-[#525252] focus:outline-none focus:border-[#E63946]" />
                  </div>
                </div>

                <Button type="submit" disabled={isSubmitting} className="w-full mt-6 bg-[#E63946] hover:bg-[#D62839] text-white font-bold py-4 rounded-xl text-lg">
                  {isSubmitting ? (
                    <><Loader2 className="w-5 h-5 animate-spin mr-2" />Sending Quote...</>
                  ) : (
                    <>Get Your Quote</>
                  )}
                </Button>

                <div className="mt-4 p-3 bg-[#E63946]/10 rounded-lg flex items-start gap-2">
                  <Info className="w-4 h-4 text-[#E63946] mt-0.5 flex-shrink-0" />
                  <p className="text-xs text-[#A3A3A3]">
                    This is an estimate only. Final quote may vary based on site conditions. 
                    We'll contact you to confirm details.
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
